import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import apiService from '../../services/apiServices';

const initialState = {
  settings: [],
  loading: false,
  error: null,
};

export const saveBarcodeSetting = createAsyncThunk(
  'barcodeSettings/saveBarcodeSetting',
  async (settings, { rejectWithValue }) => {
    try {
      const response = await apiService.post('barcode-settings', settings);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllBarcodeSettings = createAsyncThunk(
    'settings/getAllBarcodeSettings',
    async () => {
      try {
        const response = await apiService.get('barcode-settings');
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  );

  
export const updateBarcodeSetting = createAsyncThunk(
    'settings/updateSettings',
    async (settings, { rejectWithValue }) => {
      try {
        const response = await apiService.put('barcode-settings', settings);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const deleteBarcodeSetting = createAsyncThunk(
    'settings/deleteBarcodeSetting',
    async (id, { rejectWithValue }) => {
      try {
        const response = await apiService.delete(`barcode-settings/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

const barcodeSettingsSlice = createSlice({
  name: 'barcodeSettings',
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
    .addCase(getAllBarcodeSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllBarcodeSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(getAllBarcodeSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateBarcodeSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBarcodeSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(updateBarcodeSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteBarcodeSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBarcodeSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = null;
      })
      .addCase(deleteBarcodeSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(saveBarcodeSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveBarcodeSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.settings.push(action.payload.settings);
      })
      .addCase(saveBarcodeSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

 

export default barcodeSettingsSlice.reducer;